import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { ENV, coreState, coreIdentityProblem } from "@/lib/environment";

// Login gate: static configuration first, then the Core's public status document (no auth, no cookies).
export function useCoreCheck() {
  const [state, setState] = useState(() =>
    ENV.problems.length ? { status: "blocked", problems: ENV.problems } : { status: "checking", problems: [] });

  const check = useCallback(() => {
    if (ENV.problems.length) return;
    setState({ status: "checking", problems: [] });
    axios.get(`${API}/`, { withCredentials: false, timeout: 15000 })
      .then(({ data }) => {
        const problem = coreIdentityProblem(ENV, data);
        coreState.problem = problem;
        setState(problem ? { status: "blocked", problems: [problem] } : { status: "ok", problems: [] });
      })
      .catch(() => {
        coreState.problem = "core_unchecked";
        setState({ status: "unreachable", problems: [] });
      });
  }, []);

  useEffect(() => { check(); }, [check]);
  return { ...state, retry: check };
}
